import React from 'react';

import { Grid, Theme } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import AppBar from './header/AppBar';
import Footer from './Footer';

import appSettings from '../../config/appSettings';

const useStyles = (theme: Theme) => ({
    container: {
        flexGrow: 1,
        height: '100%',
    },
    main: {
        marginTop: theme.spacing(10),
        flexGrow: 1,
        height: '100%',
    },
    notMain: {
        flexGrow: 0,
    },
    layout: {
        flexGrow: 1,
        height: '100%',
        backgroundColor: theme.palette.background.paper,
    }
});

export default (props: { children?: React.ReactNode }) => {

    const classes = useStyles(useTheme());

    return (
        <React.Fragment>
            <AppBar name={appSettings.name}/>
            <Grid alignItems='stretch' sx={classes.layout} container direction='row' spacing={0} wrap='nowrap'>
                <Grid item sm={1}></Grid>
                <Grid alignItems='stretch' sx={classes.container} container direction='column'>
                    <Grid sx={classes.main} item xs>{props.children}</Grid>
                    <Grid className='flex-no-grow' item xs><Footer name={appSettings.org} /></Grid> 
                </Grid>
                <Grid item sm={1}></Grid>
            </Grid>
        </React.Fragment> 
    );
}